export const fixed = {
    "지역": "대한민국<br/>서울",
    "시험일<br/>시험 시간": "YY.MM.DD.DOW<br/>hh:mm - hh:mm",
    "접수 구분<br/>차수": "정기<br/>24년 10차",
    "시험 종목<br/>시험 등급": "번역 자격증<br/>전문1급",
    "검정과목<br/>분야/영역": "검정 과목/ 분야<br/>영역 내용",
    "시험명<br/>시험 순서": "시험명 표시 영역<br/>2교시",
    "출발어<br/>도착어": "한국어<br/>English(US)",
    "출제 목적<br/>출제 기간": "응시용<br/>YY.MM.DD ~ YY.MM.DD",
}
